
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/health/[category]",
      function () {
        return require("private-next-pages/[region]/health/[category]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/health/[category]"])
      });
    }
  